module.exports = __webpack_public_path__ + "static/Daws-20-a71f78d49710dffb4c02e1c2c5f1419b.jpg";